import React, { useEffect } from "react";
import Layout from "../../Components/Layout/Layout";
import RegisteredProgram from "./Components/Cards/RegisteredProgram";
import Champions from "./../../Components/Champions";
import Filters from "../Home/Components/Filters";
import { useDispatch, useSelector } from "react-redux";
import { getEvents } from "../../redux/actions/event";
import "./style.css";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { ongoingEventActiveFilter, pastEventActiveFilter } from "../../helper/general";
import { setFilters } from "../../redux/actions/dashboard";
import { ONGOING_EVENT_FILTER, PAST_EVENT_FILTER } from "../../redux/actions/types";

const LearningPrograms = () => {

  const dispatch = useDispatch();
  const ongoingEventFilter = useSelector(state => state.event.ongoingEventFilter);
  const pastEventFilter = useSelector(state => state.event.pastEventFilter);
  const ongoingEvents = useSelector(state => state.event.ongoingEvents);
  const pastEvents = useSelector(state => state.event.pastEvents);

  useEffect(() => {
    dispatch(getEvents({ ...ongoingEventFilter, isOnGoingProgram: true, pageNo: 0, pageSize: 500 }))
    dispatch(getEvents({ ...pastEventFilter, isOnGoingProgram: false, pageNo: 0, pageSize: 500 }))
  }, [])

  const handleOngoingFilterChange = (e) => {
    const { name, value } = e.target
    const data = { ...ongoingEventFilter }
    const index = data[name]?.indexOf(parseInt(value));
    if (index >= 0) {
      data[name].splice(index, 1)
    } else {
      data[name].push(parseInt(value));
    }
    dispatch(setFilters(ONGOING_EVENT_FILTER, data));
    dispatch(getEvents({ ...data, isOnGoingProgram: true, pageNo: 0, pageSize: 500 }))
  }

  const handlePastFilterChange = (e) => {
    const { name, value } = e.target
    const data = { ...pastEventFilter }
    const index = data[name]?.indexOf(parseInt(value));
    if (index >= 0) {
      data[name].splice(index, 1)
    } else {
      data[name].push(parseInt(value));
    }
    dispatch(setFilters(PAST_EVENT_FILTER, data));
    dispatch(getEvents({ ...data, isOnGoingProgram: false, pageNo: 0, pageSize: 500 }))
  }

  return (
    <Layout title="Learning Programs" page="learningPrograms">
      <div className="m-top-3"><div className="page-title"><h2>Learning Programs</h2></div></div>
      <div className="top-tab-btns learning-programs px-3">
        <Tabs defaultActiveKey="ongoing-programs" className="mb-3">
          <Tab eventKey="ongoing-programs" title="Ongoing programs">
            <div className="tab-pane fade show active">
              <p className="program-hdng mt-4 mb-0">Registered programs</p>
              <div className="container-fluid top-cards p-0">
                <Filters handleFilterChange={handleOngoingFilterChange} filterData={ongoingEventFilter} activeFilter={ongoingEventActiveFilter} />
                {ongoingEvents?.data?.map((data, key) => <RegisteredProgram data={data} key={key} />)}
              </div>
            </div>
          </Tab>
          <Tab eventKey="past-programs" title="Past programs">
            <div className="tab-pane fade show active">
              <p className="program-hdng mt-4 mb-0">Registered programs</p>
              <div className="container">
                <Filters handleFilterChange={handlePastFilterChange} filterData={pastEventFilter} activeFilter={pastEventActiveFilter} />
                {pastEvents?.data?.map((data, key) => <RegisteredProgram data={data} key={key} />)}
              </div>
            </div>
          </Tab>
        </Tabs>
        <p className="program-hdng mt-4 mb-2">
          All Programs offered by KidEx
        </p>
        <Champions />
      </div>
    </Layout>
  );
};

export default LearningPrograms;
